
export default class Label{
    constructor(start,end){
        this.type = 'LineString';
        this.coordinates = [[start.x,start.y],[end.x,end.y]];
    }
}
